import React, { useState } from "react";
import { Container, Row, Col, Button, Collapse } from "react-bootstrap";
import full_logo_green from "assets/images/full_logo_green.png";
import { RecipesSvg } from "assets/icons/RecipesSvg";
import { SitesSvg } from "assets/icons/SitesSvg";
import { SiteRegistrationSvg } from "assets/icons/SiteRegistrationSvg";
import {
  BANNER_GFA_TEXT,
  BANNER_CHEM_APP_TEXT,
  BANNER_CHEM_APP_RECIPE_TEXT,
  BANNER_CHEM_APP_SITE_TEXT,
  BANNER_CHEM_APP_RECIPE_USAGE_TEXT,
} from "configurations/MessageConstants";

const RegistrationBanner = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="registration-banner">
      <Container>
        <Row className="align-items-center">
          <Col lg={3} className="logo-container">
            <img
              src={full_logo_green}
              alt="Grower Freedom Alliance Logo"
              className="banner-logo"
            />
          </Col>
          <Col lg={9}>
            <div className="d-none d-lg-block">
              <h4 className="banner-title">Grower Freedom Alliance</h4>
              <small className="banner-text main-description">
                {BANNER_GFA_TEXT}
              </small>
            </div>
            <div className="d-flex d-lg-block justify-content-center justify-content-lg-start">
              <Button
                variant="link"
                onClick={() => setShowMore(!showMore)}
                aria-expanded={showMore}
                className="toggle-button"
              >
                Show {showMore ? "less" : "more"}
              </Button>
            </div>
          </Col>
        </Row>
        <Collapse in={showMore}>
          <div className="expanded-content text-center">
            <div className="d-block d-lg-none mb-4">
              <h4 className="banner-title">Grower Freedom Alliance</h4>
              <small className="banner-text main-description">
                {BANNER_GFA_TEXT}
              </small>
            </div>
            <h4 className="banner-title mb-3">Chemical Application</h4>
            <Row className="mb-1">
              <Col lg={12}>
                <p className="banner-text">{BANNER_CHEM_APP_TEXT}</p>
              </Col>
            </Row>
            <Row className="features-row">
              <Col md={4} className="text-center feature-col">
                <div className="feature-icon">
                  <RecipesSvg />
                </div>
                <p className="feature-text">{BANNER_CHEM_APP_RECIPE_TEXT}</p>
              </Col>
              <Col md={4} className="text-center feature-col">
                <div className="feature-icon">
                  <SitesSvg />
                </div>
                <p className="feature-text">{BANNER_CHEM_APP_SITE_TEXT}</p>
              </Col>
              <Col md={4} className="text-center feature-col">
                <div className="feature-icon">
                  <SiteRegistrationSvg />
                </div>
                <p className="feature-text">
                  {BANNER_CHEM_APP_RECIPE_USAGE_TEXT}
                </p>
              </Col>
            </Row>
          </div>
        </Collapse>
      </Container>
    </div>
  );
};

export default RegistrationBanner;
